var map = {
	"./bd.svg": "./src/assets/svg/lang-flags/bd.svg",
	"./br.svg": "./src/assets/svg/lang-flags/br.svg",
	"./de.svg": "./src/assets/svg/lang-flags/de.svg",
	"./en.svg": "./src/assets/svg/lang-flags/en.svg",
	"./es.svg": "./src/assets/svg/lang-flags/es.svg",
	"./globe.svg": "./src/assets/svg/lang-flags/globe.svg",
	"./hant.svg": "./src/assets/svg/lang-flags/hant.svg",
	"./id.svg": "./src/assets/svg/lang-flags/id.svg",
	"./in.svg": "./src/assets/svg/lang-flags/in.svg",
	"./jp.svg": "./src/assets/svg/lang-flags/jp.svg",
	"./kh.svg": "./src/assets/svg/lang-flags/kh.svg",
	"./kr.svg": "./src/assets/svg/lang-flags/kr.svg",
	"./mm.svg": "./src/assets/svg/lang-flags/mm.svg",
	"./ms.svg": "./src/assets/svg/lang-flags/ms.svg",
	"./pk.svg": "./src/assets/svg/lang-flags/pk.svg",
	"./pt.svg": "./src/assets/svg/lang-flags/pt.svg",
	"./ru.svg": "./src/assets/svg/lang-flags/ru.svg",
	"./th.svg": "./src/assets/svg/lang-flags/th.svg",
	"./tr.svg": "./src/assets/svg/lang-flags/tr.svg",
	"./uz.svg": "./src/assets/svg/lang-flags/uz.svg",
	"./vn.svg": "./src/assets/svg/lang-flags/vn.svg",
	"./zh.svg": "./src/assets/svg/lang-flags/zh.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg/lang-flags sync recursive ^\\.\\/.*\\.svg$";